import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import { TableContentForEmployeeSessionImageReport } from "../../../Common/Table/tableContent";
import services from "../services";
import $ from "jquery";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi from "@hapi/joi";
import { EmployeeSessionImageSchemaObject } from "../EmployeeSessionImageReportSchema";
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';
import _ from 'lodash';
import MessageModal from "../../../../UI/Modal/MessageModal";

const screenCode = "EMPLOYEESESSIONIMAGEREPORT";

export function EmployeeSessionImageReport(props) {

    const componentRef = useRef();

    const [groups, setGroups] = useState([]);
    const [estates, setEstates] = useState([]);
    const [divisions, setDivisions] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [multipleEstates, setMultipleEstates] = useState([]);

    const [leafCollectionDetails, setLeafCollectionDetails] = useState({
        groupID: "0",
        estateID: "0",
        divisionID: "0",
        date: new Date().toISOString().split("T")[0],
        narration: "0",

    });
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "",
        disciption: "",
    });
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "0",
        estate: "0",
        division: "0",
        collectionType: "0",
        date: "",
        narration: "0",

    });

    const [errors, setErrors] = useState({});

    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
    });

    const schema = Joi.object(EmployeeSessionImageSchemaObject).options({ allowUnknown: true });
    const [contentRowNames, setContentRowNames] = useState([]);
    const [tableHeaders, setTableHeaders] = useState([]);

    const [reportData, setReportData] = useState([]);

    useEffect(() => {
        trackPromise(getPermissions(),
            getGroupsForDropdown()
        );
    }, []);

    useEffect(() => {
        trackPromise(
            getEstatesForDropDown(),
        )
    }, [leafCollectionDetails.groupID])

    useEffect(() => {
        trackPromise(
            getDivisionsForDropDown()
        )
    }, [leafCollectionDetails.estateID])

    useEffect(() => {
        setReportData([]);
        setIsTableHide([]);
        setTableHeaders([]);
        setContentRowNames([]);

    }, [leafCollectionDetails.estateID]);

    useEffect(() => {
        setReportData([]);
        setIsTableHide([]);
        setTableHeaders([]);
        setContentRowNames([]);

    }, [leafCollectionDetails.divisionID]);

    useEffect(() => {
        setReportData([]);
        setIsTableHide([]);
        setTableHeaders([]);
        setContentRowNames([]);

    }, [leafCollectionDetails.groupID]);

    useEffect(() => {
        setReportData([]);
        setIsTableHide([]);
        setTableHeaders([]);
        setContentRowNames([]);

    }, [leafCollectionDetails.date]);
    useEffect(() => {
        setReportData([]);
        setIsTableHide([]);
        setTableHeaders([]);
        setContentRowNames([]);

    }, [leafCollectionDetails.narration]);

    function handleGroupChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            groupID: target.value,
            estateID: "0",
            divisionID: "0",
            narration: "0"
        });
    }

    function handleEstateChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            estateID: target.value,
            divisionID: "0",
            date: new Date().toISOString().split("T")[0],
            narration: "0"
        });
    }

    function handleDivisionChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            divisionID: target.value,
            date: new Date().toISOString().split("T")[0],
            narration: "0"
        });
    }
    function handleNarrationChange(e) {
        e.preventDefault();

        const target = e.target;
        const value = target.value;

        const error = { ...errors };
        const errorMessage = validateProperty(target, EmployeeSessionImageSchemaObject);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            [e.target.name]: value
        })
    }
    function handleDateChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            date: target.value,
        });
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, EmployeeSessionImageSchemaObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }


    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWEMPLOYEESESSIONIMAGEREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });
        var token = tokenService.getUserDetailsFromTokenV2();
        if (token.operationEntities.length > 0) {

            var estateArray = [];
            for (let item of Object.entries(token.operationEntities)) {
                estateArray[item[1]["OperationEntityID"]] = item[1]["OperationEntityName"]
            }

            setMultipleEstates(estateArray)

            setLeafCollectionDetails({
                ...leafCollectionDetails,
                groupID: token.groupID
            });

        }
        else {
            setLeafCollectionDetails({
                ...leafCollectionDetails,
                groupID: token.groupID,
                estateID: token.operationEntityID
            });
        }
        setLeafCollectionDetails({
            ...leafCollectionDetails,
            groupID: token.groupID,
            estateID: token.operationEntityID
        });
        trackPromise(getGroupsForDropdown());
    }


    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getEstatesForDropDown() {
        const data = await services.getEstatesByGroupID(leafCollectionDetails.groupID);
        setEstates(data);
    }

    async function getDivisionsForDropDown() {
        const data = await services.getAllDivisionsByEstateID(leafCollectionDetails.estateID);
        setDivisions(data);
    }


    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true });
    }

    async function handleSearch(e) {

        e.preventDefault();
        setIsTableHide(true);
        destroyDataTable();

        const errorMessages = validate(schema, leafCollectionDetails);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        getSelectedDropdownValuesForReport(leafCollectionDetails);

        const result = await services.getEmployeeSessionImageReportData(leafCollectionDetails);
        if (result.length > 0) {
            var headers = [];
            var allHeaders = [];
            var tableData = [];
            var contentHeaders = [];

            result.forEach(x => {
                allHeaders.push(x.sessionName);
            });

            allHeaders = allHeaders.sort();
            headers.push("Registration Number");
            headers.push("Name");
            headers.push("Biometric Image");
            headers.push(...[... new Set(allHeaders)]);
            contentHeaders.push("employeeCode");
            contentHeaders.push("firstName");
            contentHeaders.push("convertedEmployeeBiometricData");
            contentHeaders.push(...[... new Set(allHeaders)]);


            result.forEach(x => {
                if (tableData.length === 0) {
                    var firstRecord = {
                        [x.sessionName]: "data:image/jpg;base64," + x.employeeSessionImageData,
                        mobileSubSessionID: x.mobileSubSessionID,
                        convertedEmployeeBiometricData: x.convertedEmployeeBiometricData,
                        employeeCode: x.employeeCode,
                        firstName: x.firstName,
                        employeeID: x.employeeID
                    };
                    tableData.push(firstRecord);
                }
                else {
                    var filterdRecord = tableData.find(y => y.employeeID === x.employeeID);

                    if (filterdRecord) {
                        filterdRecord[x.sessionName] = "data:image/jpg;base64," + x.employeeSessionImageData;
                    } else {
                        var record = {
                            [x.sessionName]: "data:image/jpg;base64," + x.employeeSessionImageData,
                            mobileSubSessionID: x.mobileSubSessionID,
                            convertedEmployeeBiometricData: x.convertedEmployeeBiometricData,
                            employeeCode: x.employeeCode,
                            firstName: x.firstName,
                            employeeID: x.employeeID
                        };

                        tableData.push(record);
                    }
                }
            });

            if (tableData.length > 0) {
                setIsTableHide(false);
                setTableHeaders(headers);
                setContentRowNames(contentHeaders);
                setReportData(tableData);

                createDataTable();
            }
        }
        else {
            setMessageModel({
                ...messageModel,
                hidden: false,
                type: "Error",
                disciption: "No Records To Display",
            });
            setTimeout(() => {
                modalDismissHandler();
            }, 3000);
        }
    }

    function createDataTable() {
        $('#sessionImageTable').DataTable();
    }

    function destroyDataTable() {
        $('#sessionImageTable').DataTable().destroy();
    }

    function onCancelClick() {
        clearState();
    }

    function clearState() {
        setLeafCollectionDetails({
            ...leafCollectionDetails,
            divisionID: "0",
            date: new Date().toISOString().split("T")[0],
            narration: "0",
        });
        setIsTableHide(true);
        setErrors("");
    }


    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            estate: estates[searchForm.estateID],
            division: divisions[searchForm.divisionID],
            date: searchForm.date,
            narration: leafCollectionDetails.narration,

        })
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">

                        <PageHeader
                            title="Employee Image Session Report"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => handleSearch(e)}
                                disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={leafCollectionDetails.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="estateID">Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="estateID"
                                            id="estateID"
                                            name="estateID"
                                            value={leafCollectionDetails.estateID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleEstateChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(
                                                Object.fromEntries(
                                                    Object.entries(estates).filter(([key, value]) => {
                                                        if (key === "0" || !value) return false;
                                                        if (!multipleEstates || Object.keys(multipleEstates).length === 0) {
                                                            return true;
                                                        }
                                                        return Object.values(multipleEstates).includes(value);
                                                    })
                                                )
                                            )}
                                        </Select>
                                        {errors["estateID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["estateID"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="divisionID">Collection Point *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="divisionID"
                                            id="divisionID"
                                            name="divisionID"
                                            value={leafCollectionDetails.divisionID}
                                            onChange={(e) => handleDivisionChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Collection Point--</MenuItem>
                                            {generateDropDownMenu(divisions)}
                                        </Select>
                                        {errors["divisionID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["divisionID"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md">
                                        <TextField select fullWidth
                                            label="Job Type "
                                            id="narration"
                                            name="narration"
                                            value={leafCollectionDetails.narration}
                                            type="text"
                                            onChange={(e) => handleNarrationChange(e)}>
                                            <option value="0">--Select Job Type--</option>
                                            <option value="1">General</option>
                                            <option value="2">Kilo</option>
                                            <option value="3">Cash</option>

                                        </TextField>
                                    </div>

                                    <div className="col-md-4">
                                        <InputLabel shrink id="searchDate">Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="date"
                                            name="date"
                                            value={leafCollectionDetails.date}
                                            type="date"
                                            onChange={(e) => handleDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["searchDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["searchDate"]}</FormHelperText>)}
                                    </div>

                                </div>

                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, leafCollectionDetails)}
                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />

                                    <input type="reset"
                                        className="btn btn-warning pull-right"
                                        value="Cancel"
                                        onClick={onCancelClick}
                                    />
                                </div>
                            </form>

                            {isTableHide ? null :
                                <div>
                                    <div className="row pt-3 pb-3">
                                        <div className="col-md-12">
                                            <div className="table-responsive row-top-gap">
                                                <table id="sessionImageTable" className="display dataTable no-footer" style={{ width: "100%" }}>
                                                    <thead>
                                                        <tr>
                                                            {
                                                                tableHeaders.map((x, index) => {
                                                                    return (
                                                                        <th
                                                                            key={index}
                                                                            style={{
                                                                                textAlign: (x === "Name" || x === "Registration Number") ? "left" : "center",
                                                                                width: index < 2 ? "150px" : "auto"
                                                                            }}
                                                                        >
                                                                            {x}
                                                                        </th>
                                                                    );
                                                                })
                                                            }
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <TableContentForEmployeeSessionImageReport
                                                            data={reportData}
                                                            contentRowNames={contentRowNames}
                                                            hasEdit={false}
                                                        />
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="pt-2">
                                        <ReactToPrint
                                            documentTitle={"Employee Image Session Report"}
                                            trigger={() => (
                                                <input
                                                    type="submit"
                                                    className="btn btn-primary pull-right ml-2"
                                                    value="PDF"
                                                />
                                            )}
                                            content={() => componentRef.current}
                                        />
                                    </div>

                                    <div hidden={true}>
                                        <CreatePdf
                                            ref={componentRef}
                                            data={reportData}
                                            tableHeaders={tableHeaders}
                                            rowNames={contentRowNames}
                                            searchData={selectedSearchValues}
                                        />
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );
}
